import { Icon } from 'components/Icon'
import React from 'react'
import styled, { css, useTheme } from 'styled-components'

type CircleStyleProps = {
	color: string
	valColor?: string
}

export const circleStyles = css<CircleStyleProps>`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;

	.super-text {
		position: absolute;
		top: 0;
		left: -3px;
		transform: translateX(-100%);
		z-index: 2;
		color: ${props => props.theme.colors.primary.val};
	}

	.circle {
		max-width: 42px;
		min-width: 42px;
		height: 42px;
		border-radius: 50%;
		border: 2px solid ${props => props.color};
		display: flex;
		align-items: center;
		justify-content: center;
		.plus {
			color: ${props => props.valColor || props.color};
		}
		.value {
			font-weight: 700;
			font-size: 1.5rem;
			color: ${props => props.valColor || props.color};
		}
	}

	.pending {
		transform: translateX(-2px);
		height: 80%;
		.icon {
			color: ${props => props.color};
			max-height: 100%;
			max-width: 100%;
			display: flex;
			justify-content: center;
			svg {
				height: 100%;
				width: auto;
			}
		}
	}

	.label {
		color: ${props => props.color};
	}

	&.__is-solid {
		.circle {
			background: ${props => props.color};
			color: ${props => props.theme.colors.white.val};
			.value {
				color: ${props => props.theme.colors.white.val};
			}
			.pending {
				.icon {
					color: ${props => props.theme.colors.white.val};
				}
			}
		}
	}
	&.__disabled {
		.circle {
			border: 2px solid ${props => props.theme.colors.midNeutral.light().val};
			color: ${props => props.theme.colors.midNeutral.light().val};
			.pending {
				color: inherit;
				.icon {
					color: inherit;
				}
			}
		}

		&.__is-solid {
			.circle {
				color: ${props => props.theme.colors.white.val};
				background: ${props => props.theme.colors.midNeutral.light(5).val};
				border-color: ${props => props.theme.colors.midNeutral.light(5).val};
			}
		}
	}

	&.__small {
		.circle {
			max-width: 37px;
			min-width: 37px;
			height: 37px;
		}
	}
`

const CircleView = styled.div`
	${circleStyles}
`

export type CircleProps = {
	className?: string
	isSmall?: boolean
	isSolid?: boolean
	isPending?: boolean
	label?: string
	value?: number | null
	isDisabled?: boolean
	color?: string
	valColor?: string
	hasPlus?: boolean
	superText?: string
}
export const Circle = ({
	value,
	className,
	isSmall,
	isSolid = true,
	isPending,
	label,
	isDisabled,
	color,
	valColor,
	hasPlus,
	superText,
}: CircleProps) => {
	const { colors } = useTheme()
	return (
		<CircleView
			color={color || colors.secondary.val}
			valColor={valColor}
			className={`circle-ico${className ? ` ${className}` : ''}${label ? ' __has-label' : ''}${
				isSolid ? ' __is-solid' : ''
			}${isSmall || label ? ' __small' : ''}
    ${!isPending && !value ? ' __bg-none' : ''}
    ${isDisabled ? ' __disabled' : ''}`}
		>
			<div className={`circle`}>
				{superText ? <span className='super-text'>{superText}</span> : null}
				{isPending ? (
					<div className='pending'>
						<Icon type='clockHands' />
					</div>
				) : value ? (
					<>
						{hasPlus ? <span className='plus'>+</span> : null}
						<span className='value'>{value}</span>
					</>
				) : null}
			</div>
			{label ? <span className='label'>{label}</span> : null}
		</CircleView>
	)
}
